import React, {ReactNode, useState} from 'react';
import axios from 'axios';
import {Col, Row} from 'react-bootstrap';
import {BaseModal} from 'components/modals';
import Button from '@/components/ui/Button';
import i18n from 'i18n';
import useOptimizedConfig from '@/hooks/useOptimizedConfig';
import {useStoreActions} from 'store';

interface Props {
    helpTextTitle?: string;
    helpText: ReactNode;
}

const HelpTextBlock = React.memo<Props>((
    {
        helpTextTitle,
        helpText,
    },
) => {
    const [helpInformationOpen, setHelpInformationOpen] = useState<boolean>(false);
    const [certainText, setCertainText] = useState<boolean>(true);
    const {userData, loading: loadingUserData} = useOptimizedConfig();

    const setReloadUserData = useStoreActions((actions) => actions.userData.setReload);

    const setHelpInformation = async () => {
        setCertainText(false);

        const url = window.URLS.userPreferencesResource;

        const values = {
            helpInformation: false,
        };

        try {
            await axios.post(url, values);
            setReloadUserData(true);
        } catch (error) {
            console.error('Error updating user preferences:', error);
            setCertainText(true);
        }
    };

    const closeCertainText = () => {
        setHelpInformationOpen(false);
        setCertainText(false);
    };

    const helpTextBlock = (
        (userData?.helpInformation) ? (
            <Row>
                <Col lg={12}>
                    <div className={`alert alert-info alert-dismissible ${certainText ? null : 'hide'}`} role="alert">
                        <div>{helpText}</div>
                        <button
                            onClick={() => setHelpInformationOpen(true)}
                            type="button"
                            className="close"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </Col>
            </Row>
        ) : null
    );

    return (
        <>
            {helpTextBlock}

            <BaseModal
                isOpen={helpInformationOpen}
                onClose={() => setHelpInformationOpen(false)}
                title={i18n.t('ht_close.text')}
                footer={
                    <>
                        <Button data-dismiss="alert" onClick={() => closeCertainText()} variant="secondary">
                            {i18n.t('ht_close_only_now.text')}
                        </Button>
                        <Button onClick={() => setHelpInformation()} variant="info">
                            {i18n.t('ht_close_approve.text')}
                        </Button>
                    </>
                }
            >
                {i18n.t('ht_by_approving.text')}
            </BaseModal>
        </>
    );
});

export default HelpTextBlock;
